import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { Button, FormGroup, ControlLabel, FormControl } from 'react-bootstrap'
import MEModal from '../../components/MEModal'
import { tempAccess } from '../actions'
import PropTypes from 'prop-types'
import ButterToast, { Cinnamon } from 'butter-toast'

class TempAccess extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      tempAccessModalOpen: false,
      sendEmailModalOpen: false,
      tempAccessEmail: '',
      tempAccessFirstName: '',
      tempAccessLastName: '',
      tempAccessDays: 10,
      emailErrors: true,
    }

    this.toggleTempAccessModal = this.toggleTempAccessModal.bind(this)
    this.handleFormSubmit = this.handleFormSubmit.bind(this)
    this.handleEmailChange = this.handleEmailChange.bind(this)
    this.handleFirstNameChange = this.handleFirstNameChange.bind(this)
    this.handleLastNameChange = this.handleLastNameChange.bind(this)
    this.handleAccessDaysChange = this.handleAccessDaysChange.bind(this)
    this.getValidationState = this.getValidationState.bind(this)
    this.cleanForm = this.cleanForm.bind(this)
  }

  toggleTempAccessModal() {
    this.setState({
      tempAccessModalOpen: !this.state.tempAccessModalOpen,
    })
  }

  handleEmailChange(e) {
    this.setState({
      tempAccessEmail: e.target.value,
    })
    if (this.cleanForm()) {
      this.setState({
        emailErrors: false,
      })
    } else {
      this.setState({
        emailErrors: true,
      })
    }
  }

  handleFirstNameChange(e) {
    this.setState({
      tempAccessFirstName: e.target.value,
    })
  }

  handleLastNameChange(e) {
    this.setState({
      tempAccessLastName: e.target.value,
    })
  }

  handleAccessDaysChange(e) {
    this.setState({
      tempAccessDays: e.target.value,
    })
  }

  async handleFormSubmit(e) {
    e.preventDefault()

    let data = this.props.filters
    data.email = this.state.tempAccessEmail
    data.first_name = this.state.tempAccessFirstName
    data.last_name = this.state.tempAccessLastName
    data.days = this.state.tempAccessDays
    data.pageNum = this.props.currentCourseMemPage
    data.archivedPageNum = this.props.currentArchivePage
    let response = await this.props.tempAccess(data)

    this.toggleTempAccessModal()
    if (response.status === 200) {
      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            scheme={Cinnamon.Crunch.SCHEME_GREY}
            content="An email has been sent to the student granting temporary access."
            title="Success"
          />
        ),
      })
    } else {
      let error = response.error
      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            scheme={Cinnamon.Crunch.SCHEME_RED}
            content={error}
            title="Results"
          />
        ),
      })
    }
  }

  getValidationState() {
    if (!this.cleanForm()) {
      return 'error'
    }
  }

  cleanForm() {
    if (
      (this.state.tempAccessEmail.length > 0 &&
        /\S+@\S+/.test(this.state.tempAccessEmail)) ||
      this.state.tempAccessEmail.length === 0
    ) {
      return true
    } else {
      return false
    }
  }

  daysAccessLoop() {
    var options = []
    for (var days = 1; days <= 14; days++) {
      options.push(days)
    }
    return options
  }

  render() {
    return (
      <Fragment>
        <Button bsStyle="link" onClick={this.toggleTempAccessModal}>
          <i className="fal fa-fw fa-unlock-alt" /> Grant Temporary Access
        </Button>
        <MEModal
          show={this.state.tempAccessModalOpen}
          close={this.toggleTempAccessModal}
          title="Grant Temporary Access"
        >
          <p>
            Please enter student information below. The student will be granted
            access for 10 days.
          </p>
          <p>
            An automated email with login instructions will automatically be
            sent to the student.
          </p>
          <form>
            <FormGroup
              controlId="emailInput"
              validationState={this.getValidationState()}
            >
              <ControlLabel>Email Address</ControlLabel>
              <FormControl
                type="email"
                value={this.state.emailInput}
                onChange={this.handleEmailChange}
              />
            </FormGroup>
            <FormGroup controlId="firstNameInput">
              <ControlLabel>First Name</ControlLabel>
              <FormControl
                type="text"
                value={this.state.firstNameInput}
                onChange={this.handleFirstNameChange}
              />
            </FormGroup>
            <FormGroup controlId="lastNameInput">
              <ControlLabel>Last Name</ControlLabel>
              <FormControl
                type="text"
                value={this.state.lastNameInput}
                onChange={this.handleLastNameChange}
              />
            </FormGroup>
            <FormGroup controlId="daysInput">
              <ControlLabel>Days of Temporary Access Needed</ControlLabel>
              <FormControl
                componentClass="select"
                defaultValue={this.state.tempAccessDays}
                value={this.state.daysInput}
                onChange={this.handleAccessDaysChange}
              >
                {this.daysAccessLoop().map((x, key) => (
                  <option key={key} value={x}>
                    {x}
                  </option>
                ))}
              </FormControl>
            </FormGroup>
            <Button
              type="submit"
              className="btn-myed btn-primary-myed"
              bsStyle="primary"
              disabled={this.state.emailErrors}
              onClick={this.handleFormSubmit}
            >
              Submit
            </Button>
            <Button
              type="button"
              className="btn-myed btn-default-myed"
              bsStyle="default"
              onClick={this.toggleTempAccessModal}
            >
              Cancel
            </Button>
          </form>
        </MEModal>
      </Fragment>
    )
  }
}

TempAccess.propTypes = {
  tempAccess: PropTypes.func,
  filters: PropTypes.object,
}

const mapStateToProps = state => {
  return {
    peopleRows: state.peopleRowData,
    filters: state.filters,
    currentCourseMemPage: state.currentCourseMemPage,
    currentArchivePage: state.currentArchivePage,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    tempAccess: data => dispatch(tempAccess(data)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TempAccess)
